import React, { useEffect } from 'react';
import { Close, Pdf } from '@sharefiledev/icons';
import { Button, Progress, Spin, Tooltip, Typography } from 'antd';
import { useAppStore } from '../../../common/store';
import { t } from '../../../utils';
import { ProgressState } from '../SelectDocument/types';
import {
	FilePreview,
	PreviewLoading,
	StyledCrossButton,
	StyledFileThumbnail,
	UploadPreviewContainer,
} from './UploadPreview.styled';

const { Text } = Typography;
interface Props {
	isRemoveFileDisabled: boolean;
	setIsRemoveFileDisabled: any;
	uploadState: ProgressState;
	resetUpload: () => void;
}

export function UploadPreview({ isRemoveFileDisabled, uploadState, resetUpload }: Props) {
	const { thumbnailUrl, documentTemplate, fetchDownloadUrl, downloadUrl } = useAppStore(
		state => ({
			thumbnailUrl: state.thumbnailUrl,
			documentTemplate: state.documentTemplate,
			downloadUrl: state.downloadUrl,
			fetchDownloadUrl: state.fetchDownloadUrl,
		})
	);

	function getUploadProgress(state: ProgressState): number {
		switch (state) {
			case 'not_started':
				return 0;
			case 'started':
				return 10;
			case 'downloading':
				return 30;
			case 'storing':
				return 70;
			case 'ready':
				return 90;
			default:
				return 0;
		}
	}
	function removeFile() {
		resetUpload();
	}

	const document_fileName = documentTemplate?.file?.fileName;

	useEffect(() => {
		const onUploadCompete = async () => {
			try {
				await fetchDownloadUrl();
			} catch (_) {}
		};
		if (documentTemplate?.file && !downloadUrl) {
			onUploadCompete();
		}
	}, [documentTemplate?.file, downloadUrl, fetchDownloadUrl]);

	return (
		<UploadPreviewContainer data-testid="upload-preview-container">
			<FilePreview>
				{uploadState !== 'ready' ? (
					<>
						<PreviewLoading>
							<Spin />
						</PreviewLoading>
						<div style={{ width: '95%' }}>
							<Progress
								percent={getUploadProgress(uploadState)}
								type="line"
								showInfo={false}
							/>
						</div>
					</>
				) : (
					<>
						{thumbnailUrl ? (
							<StyledFileThumbnail
								alt={t('documentThumbnailAltText')}
								src={thumbnailUrl}
								data-testid="uploaded-file-thumnail"
							></StyledFileThumbnail>
						) : (
							<Pdf size={62} />
						)}

						<Tooltip
							placement="right"
							title={isRemoveFileDisabled ? t('removeFileDisabledTooltip') : ''}
						>
							<StyledCrossButton>
								<Button
									type="primary"
									shape="circle"
									icon={<Close size={20} />}
									onClick={removeFile}
									aria-label="Remove File"
									data-testid="remove-file"
									disabled={isRemoveFileDisabled}
									size="small"
									style={{
										padding: '0px',
										minWidth: '24px',
										width: '24px',
										height: '24px',
									}}
								></Button>
							</StyledCrossButton>
						</Tooltip>
					</>
				)}
			</FilePreview>
			{document_fileName && (
				<Tooltip title={document_fileName} placement="top">
					<Text data-testid="document_fileName" type="secondary">
						{document_fileName}
					</Text>
				</Tooltip>
			)}
		</UploadPreviewContainer>
	);
}
